import { Trans } from '@lingui/react/macro'
import CantileverButton from 'components/CantileverButton'
import { useChartSlashCommandContext } from 'features/richText/contexts/ChartSlashCommandContext'
import { TimeSeriesScatterplot, useResolvedChart } from 'features/timeSeries'
import React, { useState } from 'react'
import styled from 'styled-components'

import { SlashCommandCardProps } from './DefaultSlashCommandCard'
import {
  SlashCommandCard,
  SlashCommandCardBody,
  SlashCommandCardHeader,
  SlashCommandCardIcon,
  SlashCommandCardInfo,
  SlashCommandCardMeta,
  SlashCommandCardName,
  SlashCommandCardType,
  SlashCommandChip,
  SlashCommandChipIcon,
  SlashCommandModal,
  SlashCommandModalBody,
  SlashCommandModalContent,
  SlashCommandModalHeader,
} from './sharedStyles'

const ChartContainer = styled.div`
  height: 20rem;
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 0.25rem;
  margin: 1rem;
  display: flex;
  flex-direction: column;
`

export const ChartSlashCommandCard: React.FC<SlashCommandCardProps> = ({
  entryType,
  entryID,
  entryName,
  isEditMode,
  metadata,
}) => {
  const [showModal, setShowModal] = useState(false)
  const { forceRichDisplay } = useChartSlashCommandContext()

  const handleCloseModal = () => {
    setShowModal(false)
  }
  const siteID = metadata?.siteId

  const { chart } = useResolvedChart(entryID)
  const chartName = chart?.name
  const chartDescription = chart?.description

  const handleClick = () => {
    if (isEditMode) {
      setShowModal(true)
    }
  }

  if (isEditMode && !forceRichDisplay) {
    return (
      <>
        <SlashCommandChip
          onClick={handleClick}
          title={`${entryType}: ${entryName}`}>
          <SlashCommandChipIcon>C</SlashCommandChipIcon>
          {entryName}
        </SlashCommandChip>
        {showModal && (
          <SlashCommandModal onClick={handleCloseModal}>
            <SlashCommandModalContent onClick={(e) => e.stopPropagation()}>
              <SlashCommandModalHeader>
                <Trans>Metadata for Chart</Trans>
              </SlashCommandModalHeader>
              <SlashCommandModalBody>
                <p>
                  <strong>
                    <Trans>Entry:</Trans>
                  </strong>{' '}
                  {entryName}
                </p>
                <p>
                  <strong>
                    <Trans>ID:</Trans>
                  </strong>{' '}
                  {entryID}
                </p>
                {chart?.name && (
                  <p>
                    <strong>
                      <Trans>Name:</Trans>
                    </strong>{' '}
                    {chart?.name}
                  </p>
                )}
                {chart?.description && (
                  <p>
                    <strong>
                      <Trans>Description:</Trans>
                    </strong>{' '}
                    {chart?.description}
                  </p>
                )}
              </SlashCommandModalBody>
              <CantileverButton primary onClick={handleCloseModal}>
                <Trans>Close</Trans>
              </CantileverButton>
            </SlashCommandModalContent>
          </SlashCommandModal>
        )}
      </>
    )
  }

  // In view mode, show rich display
  return (
    <SlashCommandCard $isEditMode={false} $disableHovering={true}>
      <SlashCommandCardHeader>
        <SlashCommandCardIcon>C</SlashCommandCardIcon>
        <SlashCommandCardInfo>
          <SlashCommandCardName>{entryName}</SlashCommandCardName>
          <SlashCommandCardType>
            <Trans>Chart</Trans>
          </SlashCommandCardType>
        </SlashCommandCardInfo>
      </SlashCommandCardHeader>
      <SlashCommandCardBody $isEditMode={false}>
        <SlashCommandCardMeta>
          {chartName && (
            <span>
              <Trans>Name: {chartName}</Trans>
            </span>
          )}
          {chartDescription && (
            <span>
              <Trans>Description: {chartDescription}</Trans>
            </span>
          )}
        </SlashCommandCardMeta>
        <TimeSeriesScatterplot
          chartID={entryID}
          showChartSettings={false}
          siteID={siteID ?? ''}
          chartContainer={ChartContainer}
          hideSidebar={true}
          hideHeader={true}
          hideFooter={true}
        />
      </SlashCommandCardBody>
    </SlashCommandCard>
  )
}
